import { render, staticRenderFns } from "./OldBaseButton.vue?vue&type=template&id=0820545d&"
import script from "./OldBaseButton.vue?vue&type=script&lang=js&"
export * from "./OldBaseButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports